export interface IPeninsulaDocument {
  id: string;
  createdDate: string;
  createdBy: string;
  title: string;
  questionnaireId: string;
  fileUrl: string;
  version: string;
  status: string;
  modifiedBy: string;
  modifiedDate: string;
  name: string
}
export class PeninsulaDocument {
  id: string;
  createdDate: string;
  createdBy: string;
  title: string;
  questionnaireId: string;
  fileUrl: string;
  version: string;
  status: string;
  modifiedBy: string;
  modifiedDate: string;
  name: string;
}

export interface IGenerateDocumentResponse {
  instanceId: string;
  statusQueryGetUri: string;
  message: string;
  clientId?: string;
  answerSetId?: string;
  documentCount?: number;
}

export interface IGenerateDocumentStatusResponse {
  instanceId: string;
  runtimeStatus: string;
  input: any;
  output: any;
  createdTime: string;
  lastUpdatedTime: string;
}